import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon CaretRightAccountIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const CaretRightAccountIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 24 24">
      <g clipPath="url(#clip0_6783_5259)">
        <path
          d="M8.49851 17.9997C8.49877 17.7612 8.58425 17.5307 8.73951 17.3497L13.3245 11.9997L8.74151 6.65068C8.56887 6.44937 8.48326 6.18773 8.50352 5.92331C8.52377 5.65889 8.64823 5.41334 8.84951 5.24068C9.05082 5.06803 9.31246 4.98243 9.57688 5.00268C9.8413 5.02293 10.0868 5.14739 10.2595 5.34868L15.4025 11.3487C15.5574 11.5298 15.6426 11.7603 15.6426 11.9987C15.6426 12.237 15.5574 12.4675 15.4025 12.6487L10.2595 18.6487C10.1268 18.8044 9.94952 18.9156 9.75161 18.9674C9.55369 19.0191 9.34466 19.009 9.15271 18.9382C8.96075 18.8675 8.79512 18.7396 8.67814 18.5717C8.56116 18.4039 8.49846 18.2043 8.49851 17.9997Z"
          fill="#0F69AF"
        />
      </g>
      <defs>
        <clipPath id="clip0_6783_5259">
          <rect
            width={24}
            height={24}
            fill="white"
            transform="translate(1.04907e-06 24) rotate(-90)"
          />
        </clipPath>
      </defs>
    </Icon>
  )
}
export default CaretRightAccountIcon
